import { Button } from "@shapr3d/frontend-lib";
import classNames from "classnames";

import useTracker from "../../../../utils/useTracker";

import style from "./StartModelingButton.module.css";

export const StartModelingButton = () => {
  const tracker = useTracker();
  return (
    <Button
      className={classNames(style.tryShaprButton)}
      variant="grayscale"
      onClick={() => {
        tracker.trackButtonClick({ elementId: "webviewer-redirect" });
        window.open("https://www.shapr3d.com/download");
      }}
    >
      Start modeling
    </Button>
  );
};
